import { ApplicationConfig, provideZoneChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { provideEchartsCore } from 'ngx-echarts';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, ClipboardCheck, UserCheck, Table, TriangleAlert, Mail,
    ShieldCheck, FileText, Cpu, Settings, ChevronDown, ChevronRight, ChevronLeft,
    Plus, Check, X, Menu, Bell, Calendar, CalendarDays, Users, AlertCircle,
    RefreshCw, Save, Send, Lock, Unlock, PanelLeftClose, PanelLeftOpen, Info
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'attendance',
            title: 'Attendance',
            manual: () => import('./help/attendance.manual').then(m => m.ATTENDANCE_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        provideEchartsCore({ echarts: () => import('echarts') }),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, ClipboardCheck, UserCheck, Table, TriangleAlert, Mail,
                ShieldCheck, FileText, Cpu, Settings, ChevronDown, ChevronRight, ChevronLeft,
                Plus, Check, X, Menu, Bell, Calendar, CalendarDays, Users, AlertCircle,
                RefreshCw, Save, Send, Lock, Unlock, PanelLeftClose, PanelLeftOpen, Info
            })
        }
    ]
};
